// advanced-pie-chart.component.ts
import { Component, ElementRef, HostListener, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild, AfterViewInit } from '@angular/core';
import { ColorHelper, ScaleType } from '@swimlane/ngx-charts';
import { ChartData } from '../../models/chart.model';

@Component({
  selector: 'advanced-pie-chart',
  templateUrl: './advanced-pie-chart.component.html',
  styleUrls: ['./advanced-pie-chart.component.scss']
})
export class AdvancedPieChartComponent {
  @Input() name: string = "Chart Title";
  @Input() title: string = 'Total'; // the title of the chart
  @Input() results: ChartData[]; //The chart's data
  @Input() customColors: any = undefined; // custom colors for the chart. Used to override a color for a specific value
  @Input() gradient: boolean = false; // fill elements with a gradient instead of a solid color
  @Input() activeEntries: object[] = []; // elements to highlight
  @Input() label: string = 'Total'; // the text to show under the total value
  @Input() tooltipDisabled: boolean = false; // show or hide the tooltip
  @Input() tooltipTemplate: TemplateRef<any> = undefined; // a custom ng-template to be displayed inside the tooltip
  @Input() view: number[]; // the size of the chart
  @Input() nameFormatting: (name: string) => string = (name: string) => name.toUpperCase(); // function that formats name in the chart legend
  @Input() valueFormatting: (value: number) => number = (value: number) => value; // function that formats the numerical value in the chart legend
  @Input() percentageFormatting: (percentage: number) => string | number = (percentage: number) => percentage + '%'; // function that formats the percentage number in the chart legend
  animations: boolean = true;
  scheme = 'nightLights';
  colorHelper: ColorHelper;
}
